enum MiniConfigurationSummaryPrimaryButtonTypeEnum {
	addToBag = 'addToBag',
	applyChanges = 'applyChanges',
	next = 'next'
}

export default MiniConfigurationSummaryPrimaryButtonTypeEnum;
